export default function speedBumpTabbing() {
    const twoClickClass = document.getElementsByClassName('twoClick');
    const speedBumpTrapFocus = () => {
        const el = document.getElementById('speed-bump');
        const focusableEls = el.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
        const firstFocusableEl = focusableEls[1];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        const KEYCODE_TAB = 9;

        el.addEventListener('keydown', function(e) {
            let isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
            if(!isTabPressed) {
                return;
            }
            if(e.shiftKey) {
                if(document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                if(document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    };

    for (let i = 0; i < twoClickClass.length; i++) {
        twoClickClass[i].addEventListener('click', function() {
            speedBumpTrapFocus();
        }, false);
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/speed-bump-modal-tabbing.js